import styled, { css } from 'styled-components'
import { ReactComponent as ImagePlaceholder } from '@sketch/icons/image-placeholder-64-svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

const thumbnailCommon = css`
  width: 100%;
  height: 390px;
  border-radius: ${({ theme }) => theme.radii.xlarge};
`

export const NoImageThumbnail = styled.div`
  ${thumbnailCommon}

  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
`

export const ThumbnailPlaceholder = styled.div`
  ${thumbnailCommon}
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
`

export const NamePlaceholder = styled.div`
  width: 40%;
  height: 100%;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border-radius: ${({ theme }) => theme.radii.xlarge};
`

export const Name = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.F};
  line-height: 1.4;
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  overflow: hidden;
`

export const Thumbnail = styled.img`
  ${thumbnailCommon}
  object-fit: cover;

  transition: box-shadow ${({ theme }) => theme.transitions.duration[3]};

  :hover {
    box-shadow: 0 4px 12px 0 ${({ theme }) => theme.colors.border.A},
      0 12px 40px 0 ${({ theme }) => theme.colors.border.A};

    + ${Name} {
      color: ${({ theme }) => theme.colors.foreground.secondary.B};
    }
  }
`

export const NoImageIcon = styled(ImagePlaceholder).attrs({ role: 'img' })`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.55;
  width: 64px;
  height: 64px;
`
